module.exports = __webpack_public_path__ + "Roboto-Light.054fa50baa6598a7bf0c.svg";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-Light.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Light.svg
// module chunks = styles